import React from "react"
import styled, { css } from "styled-components"
import { colors, responsive } from "buoy-theme"
import { Link, Arrow } from "buoy-core"
import SubsectionArrow from "./SubsectionArrow"
import { toLink } from "../common"

const Subsection = css`
  background: white;
  display: flex;
  justify-content: space-between;
  padding: 32px 16px 32px 24px;
  border-top: 1px solid ${colors.neutralLightest};
`

export const SubsectionDisplay = styled.div`
  ${Subsection};
`

const SubsectionButton = styled.button`
  border: none;
  align-items: center;
  appearance: none;
  box-shadow: none;
  transition: all 0.25s ease;
  ${Subsection};
  :hover {
    box-shadow: inset 0 0 14px 0 #00000018;
    padding: 32px 12px 32px 24px;
  }
  ${props => props.dashboard
    ? responsive("display", "flex", "flex", "none", "none", "none")
    : ""
  };
`

export const SubsectionAction = ({ title, link, dashboard }) => (
  <SubsectionButton onClick={toLink(link)} dashboard={dashboard}>
    <Link color="black" underline={false}>
      {title}
    </Link>
    <SubsectionArrow>
      <Arrow />
    </SubsectionArrow>
  </SubsectionButton>
)



// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/components/Subsection.js